// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.ryipay",
    name: "RYIPAY",
    homepage: "https://ryipay.app/",
    image_id: "2f0918f7-f135-4b62-4765-ac183f14e500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/ryipay-wallet/id1620995066",
        android: "https://play.google.com/store/apps/details?id=io.ryi.pay",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "ryipay://",
        universal: "https://ryipay.page.link/3N7P",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map